// React
import React, { useState, useRef, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import "../index.css";
import backIcon from "../../../img/Arrow.png";
import AddAddress from "../../../Store/Cart/Components/Modals/AddAddress";
// 3rd party libs
import FloatingLabelInput from "react-floating-label-input";
// Utilities
import { saveAddress } from "../../../Redux/Actions/userActions";
import { editAddress, saveNewAddress } from "../../../Request/UserRequests";
import Input from "../../../Others/Input";
import SelectArea from "../../Cart/Components/Address & Payemnet Page/Components/SelectArea";
import Loading from "../../../Others/Loading";
const PINCODE = 124507;
const EditAddress = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [showbtmSheet, setShowbtmSheet] = useState(false);
  const formAddressRef = useRef();
  const formNameRef = useRef();
  const formPhnNumberRef = useRef();
  const dispatch = useDispatch();
  const userCurrentLocation = useSelector(
    (state) => state.user.currentLocation
  );
  const user = useSelector((state) => state.user?.info);
  const userAddress = useSelector((state) => state.user?.address);

  const addressToEdit = useMemo(
    () =>
      userAddress
        ? userAddress.filter((address) => {
            if (address.addressId == id) {
              return address;
            }
          })
        : null,
    [userAddress]
  );
  var { area, city, pincode, state, lat, long } = userCurrentLocation || {
    area: "",
    city: "Bahadurgarh",
    pincode: PINCODE,
    state: "Haryana",
    lat: null,
    long: null,
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    let current = {
      name:
        formNameRef?.current?.value.length > 1
          ? formNameRef?.current?.value
          : addressToEdit[0].name,
      address:
        formAddressRef?.current?.value.length > 1
          ? formAddressRef?.current?.value
          : addressToEdit[0].address,
      phn: formPhnNumberRef?.current?.value, // this needs to be fixed
      area: area ? area : addressToEdit[0].area,
      city: city,
      state: state,
      pincode: PINCODE,
      primary: addressToEdit[0].primary,
    };
    editAddress(id, user?.userHash, current).then((res) => {
      const newCopy = JSON.parse(JSON.stringify(userAddress));

      const index = newCopy.findIndex((el) => {
        if (el.addressId == id) {
          return true;
        }
      });
      newCopy[index] = {
        ...current,
        addressId: res.addressId,
        lat: lat,
        long: long,
      };
      dispatch(saveAddress(newCopy));
      navigate(-1);
    });
   
  };

  return addressToEdit && addressToEdit?.length>0 ? (
    <div className="ma1">
      <div className="ma2 fixed-top d-flex align-items-center transition text-orange bg-white ">
        <div className="text-center my-auto ma3">
          <img src={backIcon} alt="" width={24} onClick={() => navigate(-1)} />
        </div>
        <div className="w-100 my-auto overflow-hidden">
          <h2 className="ma4">Edit Address</h2>
        </div>
      </div>

      <div className="bg-white address-card">
        <div className="d-flex align-items-center justify-content-between sec-title">
          <h2 className="ma5">Delivery Address</h2>
        </div>

        <>
          <form onSubmit={onSubmitHandler}>
            <div className="method-input form-floating">
              {/* main address */}
              <input
                id="addaddress"
                name="address"
                className="floating-label editableInput"
                placeholder={addressToEdit[0].address}
                ref={formAddressRef}
              />
              <label for="addaddress">Address line</label>
            </div>

            <div className="method-input">
              <label
                style={{
                  fontSize: "12px",
                  padding: "8px 10px",
                  zIndex: "1",
                }}
              >
                Area
              </label>

              <div
                className="form-select"
                style={{ minHeight: "50px" }}
                onClick={() => setShowbtmSheet(true)}
              >
                {area ? area : addressToEdit[0].area}
              </div>
            </div>
            <div className="method-input">
              <FloatingLabelInput
                id="addcity"
                label="City"
                name="city"
                className="floating-label animate-2 animate-2 w-100"
                value={city}
                readOnly
                disabled
              />
            </div>
            <div className="d-flex" style={{ margin: "0 -4px" }}>
              <div style={{ padding: "0 4px", width: "50%" }}>
                <div className="method-input">
                  <label
                    style={{
                      fontSize: "12px",
                      padding: "8px 10px",
                      zIndex: "1",
                    }}
                  >
                    Pincode
                  </label>
                  <Input
                    value={PINCODE}
                    disabled
                    readOnly
                    dotPrecision={0}
                    name="pin"
                    className="floating-label"
                  />
                  <div
                    style={{
                      position: "absolute",
                      right: "2px",
                      bottom: "50%",
                      transform: "translate(0%,70%)",
                    }}
                  ></div>
                </div>
              </div>
              <div style={{ padding: "0 4px", width: "50%" }}>
                <div className="method-input">
                  <FloatingLabelInput
                    id="addstate"
                    label="State"
                    name="state"
                    className="floating-label animate-2 animate-2 w-100"
                    value={state}
                    readOnly
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="d-flex" style={{ margin: "0 -4px" }}>
              <div style={{ padding: "0 4px", width: "50%" }}>
                <div className="method-input form-floating">
                  <input
                    id="addName"
                    name="name"
                    className="floating-label editableInput"
                    placeholder={addressToEdit[0].name}
                    ref={formNameRef}
                  />
                  <label for="addName">Full Name</label>
                </div>
              </div>
              <div style={{ padding: "0 4px", width: "50%" }}>
                <div className="method-input  form-floating">
                  <input
                    id="addPhn"
                    name="phn"
                    label="Mobile No."
                    placeholder={addressToEdit[0].phn}
                    className="floating-label editableInput"
                    ref={formPhnNumberRef}
                  />
                  <label for="addPhn">Mobile Number</label>
                </div>
              </div>
            </div>

            <div className="bottom-bar">
              <div style={{ marginTop: "8px", borderRadius: "8px 8px 0 0" }}>
                <button
                  type="submit"
                  className="btn w-100 btn-orange text-orange"
                >
                  Save &amp; Continue
                </button>
              </div>
            </div>
            <SelectArea show={showbtmSheet} setShowbtmSheet={setShowbtmSheet} />
          </form>
        </>
      </div>
    </div>
  ) : (
    <Loading />
  );
};
export default EditAddress;
